import React from "react";
import OurSuccess from "../component/OurSuccess";
import BreadCumb from "../component/BreadCumb";
import Training from "../component/Training";
import SectionPage from "../component/SectionPage";
import {Helmet} from "react-helmet-async";
const TrainingPage = () => {
    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | Training & Skills</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href={`https://tarifoverseasltd.com/training`}/>
            </Helmet>
            <main className="main">
                <BreadCumb image="training.webp" />
                <Training />
                <SectionPage />
            </main>
        </>
    );
}

export default TrainingPage;
